import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Footer.css';

const Footer = () => (
  <footer className="site-footer">
    <div className="row column">
      <nav className="footer-nav">
        <Link to="/aboutus">About Us</Link> | <Link to="/contact">Contact</Link> | <Link to="/blog">Blog</Link> |{' '}
        <Link to="/news">News</Link>
      </nav>
    </div>
    <div className="row column">
      <a
        href="https://www.linkedin.com/company/syntax-nebula"
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginRight: '10px' }}
      >
        <img src="/images/in.png" alt="linked-in" width="30" />
      </a>
      <a href="https://x.com/syntaxnebula" target="_blank" rel="noopener noreferrer">
        <img src="/images/x_small.webp" alt="X" width="30" />
      </a>
    </div>
    <div className="row column">
      <div className="footer-legal">
        &copy;Syntax Nebula {new Date().getFullYear()}
        <br />
        All rights reserved
        <br />
      </div>
      <div className="footer-info">
        <a href="/gdpr">Privacy policy</a>
      </div>
      <div className="footer-info">
        We use cookies only for secure login and to remember your choices on the site, such as the training category you
        last viewed. We use no tracking or advertising cookies.
      </div>
      <div className="footer-info">Images created with ChatGPT and Grok. Video created with Runway.</div>
    </div>
  </footer>
);

export default Footer;
